"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Store = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseKey"));

var _toolkit = require("@reduxjs/toolkit");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var defaultConfig = {
  devTools: true,
  middleware: [],
  reducers: {}
};

var _config = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_config");

var _store = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_store");

var _reducers = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_reducers");

var _createReducers = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_createReducers");

var Store = /*#__PURE__*/function () {
  function Store(config) {
    (0, _classCallCheck2["default"])(this, Store);
    Object.defineProperty(this, _createReducers, {
      value: _createReducers2
    });
    Object.defineProperty(this, _config, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _store, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _reducers, {
      writable: true,
      value: {}
    });
    (0, _classPrivateFieldLooseBase2["default"])(this, _config)[_config] = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, defaultConfig), config);
  }

  (0, _createClass2["default"])(Store, [{
    key: "config",
    get: function get() {
      return (0, _classPrivateFieldLooseBase2["default"])(this, _config)[_config];
    }
  }, {
    key: "store",
    get: function get() {
      return (0, _classPrivateFieldLooseBase2["default"])(this, _store)[_store];
    }
  }, {
    key: "addReducer",
    value: function addReducer(name, reducer) {
      if (!name) {
        return void 0;
      }

      if (!reducer) {
        return void 0;
      }

      if (name in (0, _classPrivateFieldLooseBase2["default"])(this, _reducers)[_reducers]) {
        return void 0;
      }

      (0, _classPrivateFieldLooseBase2["default"])(this, _reducers)[_reducers] = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, (0, _classPrivateFieldLooseBase2["default"])(this, _reducers)[_reducers]), {}, (0, _defineProperty2["default"])({}, name, reducer));
      this.store.replaceReducer((0, _classPrivateFieldLooseBase2["default"])(this, _createReducers)[_createReducers]((0, _classPrivateFieldLooseBase2["default"])(this, _reducers)[_reducers]));
    }
  }, {
    key: "create",
    value: function create(preloadedState) {
      (0, _classPrivateFieldLooseBase2["default"])(this, _reducers)[_reducers] = this.config['reducers'];
      (0, _classPrivateFieldLooseBase2["default"])(this, _store)[_store] = (0, _toolkit.configureStore)({
        devTools: this.config['devTools'],
        reducer: !!Object.keys((0, _classPrivateFieldLooseBase2["default"])(this, _reducers)[_reducers]).length ? (0, _toolkit.combineReducers)((0, _classPrivateFieldLooseBase2["default"])(this, _reducers)[_reducers]) : {},
        preloadedState: preloadedState !== null && preloadedState !== void 0 ? preloadedState : {},
        middleware: [_reduxThunk["default"]].concat((0, _toConsumableArray2["default"])(this.config['middleware']))
      });
    }
  }]);
  return Store;
}();

exports.Store = Store;

function _createReducers2(reducers) {
  return (0, _toolkit.combineReducers)(reducers);
}